export const ToastStatus = Object.freeze({
  Error: 'error',
  Success: 'success',
  Warning: 'warning',
  Info: 'info',
});
